import React from 'react';
import { connect } from 'react-redux';
import { RootState } from '../../../state/store/store';
import { auditSelectors } from '../../../state/ducks/audit/selectors';
import { userSelectors } from '../../../state/ducks/user/selectors';
import { AuditLogFilters } from '../../../models/entities/audit/auditLog';
import { claimsDomainsType } from '../../../userClaims';
import AuditDashboardPage from './AuditDashboardPageRefactored';
import ExceptionPage from '../ExceptionPage/ExceptionPage';

type Props = {
    // State
    loading: ReturnType<typeof auditSelectors.loading>;
    getUserClaims: (domain: claimsDomainsType) => any;
    groupedAuditLogs: ReturnType<typeof auditSelectors.groupedAuditLogs>;
    groupedPagination: ReturnType<typeof auditSelectors.groupedPagination>;
    currentFilters: ReturnType<typeof auditSelectors.currentFilters>;

    // Actions
    fetchMetadata: () => void;
    fetchGroupedAuditLogs: (filters?: AuditLogFilters, loadMore?: boolean) => void;
};

const AuditDashboardPageConnected: React.FC<Props> = (props) => {
    // Check if user has admin access
    const hasAdminAccess = props.getUserClaims('admin').view;

    if (!hasAdminAccess) {
        return (
            <ExceptionPage
                status={403}
                title="Access Denied"
                subTitle="You don't have permission to access the audit trail."
            />
        );
    }

    const localization = {
        title: 'Audit Trail',
        filter: {
            filter_btn: 'Filter'
        }
    };

    return (
        <AuditDashboardPage
            localization={localization}
            showLoader={props.loading}
            loading={props.loading}
            fetchGroupedAuditLogs={props.fetchGroupedAuditLogs}
            fetchMetadata={props.fetchMetadata}
            groupedAuditLogs={props.groupedAuditLogs}
            groupedPagination={props.groupedPagination}
            currentFilters={props.currentFilters}
        />
    );
};

const mapStateToProps = (state: RootState) => {
    return {
        loading: auditSelectors.loading(state),
        getUserClaims: (domain: claimsDomainsType) => userSelectors.getUserClaims(state)(domain),
        groupedAuditLogs: auditSelectors.groupedAuditLogs(state),
        groupedPagination: auditSelectors.groupedPagination(state),
        currentFilters: auditSelectors.currentFilters(state)
    };
};

const mapDispatchToProps = (dispatch: any) => ({
    fetchMetadata: () => dispatch.audit.fetchMetadata(),
    fetchGroupedAuditLogs: (filters?: AuditLogFilters, loadMore: boolean = false) =>
        dispatch.audit.fetchGroupedAuditLogs(filters, loadMore)
});

export default connect(mapStateToProps, mapDispatchToProps)(AuditDashboardPageConnected);
